import { react2angular } from 'react2angular';

import app from '../../../browser/addform/scripts/app';
import { ThankPageBannerContainer } from './ThankPageBanner';

app.component('cianAfThankPageBanner', react2angular(ThankPageBannerContainer, [], ['config', 'httpApi', 'logger']));
